"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Equivalent = void 0;
const Exps = __importStar(require("../exp"));
const macro_1 = require("../macro");
const span_1 = require("../span");
class Equivalent extends macro_1.Macro {
    constructor(type, from, rest, span) {
        super();
        this.type = type;
        this.from = from;
        this.rest = rest;
        this.span = span;
    }
    expand() {
        if (this.rest.length === 0) {
            /**
               equivalent type { from }
               => the(Equal(type, from, from), refl)
            **/
            return Exps.ApUnfolded(Exps.Var("the"), [
                Exps.ArgPlain(Exps.ApUnfolded(Exps.Var("Equal"), [
                    Exps.ArgPlain(this.type),
                    Exps.ArgPlain(this.from),
                    Exps.ArgPlain(this.from),
                ], this.span)),
                Exps.ArgPlain(Exps.Var("refl")),
            ], this.span);
        }
        if (this.rest.length === 1) {
            /**
               equivalent type { from | via = to }
               => the(Equal(type, from, to), via)
            **/
            const via = this.rest[0].via || Exps.Var("refl");
            const to = this.rest[0].to;
            return Exps.ApUnfolded(Exps.Var("the"), [
                Exps.ArgPlain(Exps.ApUnfolded(Exps.Var("Equal"), [
                    Exps.ArgPlain(this.type),
                    Exps.ArgPlain(this.from),
                    Exps.ArgPlain(to),
                ], this.span)),
                Exps.ArgPlain(via),
            ], this.span);
        }
        /**
           equivalent type { from | via1 = to1 | via2 = to2 }
           => equalCompose(implicit type, implicit from, implicit to1, implicit to2, via1, via2)
        **/
        let result = Exps.ApUnfolded(Exps.Var("equalCompose"), [
            Exps.ArgImplicit(this.type),
            Exps.ArgImplicit(this.from),
            Exps.ArgImplicit(this.rest[0].to),
            Exps.ArgImplicit(this.rest[1].to),
            Exps.ArgPlain(this.rest[0].via || Exps.Var("refl")),
            Exps.ArgPlain(this.rest[1].via || Exps.Var("refl")),
        ], (0, span_1.spanUnion)(this.from.span, this.rest[1].to.span));
        /**
           equivalent type { from | ... | ... = lastTo | via = to }
           => equalCompose(implicit type, implicit from, implicit lastTo, implicit to, ..., via)
        **/
        let lastTo = this.rest[1].to;
        for (const next of this.rest.slice(2)) {
            result = Exps.ApUnfolded(Exps.Var("equalCompose"), [
                Exps.ArgImplicit(this.type),
                Exps.ArgImplicit(this.from),
                Exps.ArgImplicit(lastTo),
                Exps.ArgImplicit(next.to),
                Exps.ArgPlain(result),
                Exps.ArgPlain(next.via || Exps.Var("refl")),
            ], (0, span_1.spanUnion)(lastTo.span, next.to.span));
            lastTo = next.to;
        }
        return result;
    }
}
exports.Equivalent = Equivalent;
//# sourceMappingURL=Equivalent.js.map